export default {
  priv: 'pr_manage',
  overviewTitle: 'Eenheden',
  detailTitle: 'Eenheid',
  deleteTitle: 'deze eenheid',
  url: '/manage/unittypes',
  apiUrl: '/unittypes/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'unittypes',
  quickFilter: {
    text: 'Zoeken',
    value: 'short',
    type: 'text'
  },
  tableFields: [
    {
      text: 'Eenheid',
      value: 'full',
      link: '/manage/unittypes/{id}',
      width: '20%'
    },
    {
      text: 'Afkorting',
      value: 'short',
      sortable: false,
      width: '15%'
    },
    {
      text: 'Omschrijving',
      value: 'description',
      sortable: false,
      width: '20%'
    },
    {
      text: 'Vast bedrag',
      value: 'fixed_amount',
      sortable: false,
      width: '5%',
      type: 'boolean'
    }
  ]
};
